import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { RefundGivingPaymentResponse } from './types';

type RefundMemberGivingPaymentParams = {
  memberId: string;
  givingPaymentId: string;
};

export async function refundMemberGivingPayment({ memberId, givingPaymentId }: RefundMemberGivingPaymentParams) {
  const url = `/web/studio/users/${memberId}/giving-payments/${givingPaymentId}/refund`;

  const response = await api.executePostRequest<ObjectResponse<RefundGivingPaymentResponse>>(url, {});

  return response.data;
}
